import { Paper, Box, Typography } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import * as React from "react";
import { getEventMatches } from "../api/event";
import { useEffect, useState } from "react";
import { getPendingUser } from "../api/user";
import { pendingUsersColumns } from "../columns/pendingUsersColumns";
import { useNavigate } from "react-router-dom";

async function GetEventMatches(event, teamNumber) {
  console.log("getting");
  try {
    const data = await getEventMatches(event, teamNumber);
    return data;
  } catch (error) {
    console.error("Error fetching matches:", error);
    return { body: JSON.stringify({ data: [] }) };
  }
}

export default function EventMatchesGrid({ event, team }) {
  const navigate = useNavigate();
  const [matchData, setMatchData] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const result = await GetEventMatches(event, team);
      console.log(result);
      try {
        const sortedData = result.sort((a, b) => a.time - b.time);
        setMatchData(sortedData);
        console.log(sortedData);
      } catch (error) {
        console.error("Error parsing user data:", error);
        setMatchData([]);
      }
    };

    fetchData();
  }, [team, event]);

  const handleTeamClicked = (clickedTeam) => {
    navigate(`/analysis/event/${event}/team/${clickedTeam}`);
  };

  return (
    <Box sx={{ width: "100%", display: "flex", alignContent: "center" }}>
      <DataGridPro
        rows={matchData}
        columns={[
          {
            headerName: "Match",
            field: "match",
            flex: 3,
            headerAlign: "center",
            align: "center",
            editable: false,
            valueGetter: (params) =>
              `${
                params.row.comp_level == "qm"
                  ? `Qual ${params.row.match_number}`
                  : params.row.comp_level == "sf"
                  ? "Semi-Finals"
                  : "Finals"
              }`,
            cellClassName: (params) =>
              matchData.findIndex((row) => row.time === params.row.time) % 2 ===
              1
                ? "grey-cell-light"
                : "grey-cell-dark",
          },
          {
            headerName: "Red 1",
            field: "red1",
            flex: 1.5,
            headerAlign: "center",
            align: "center",
            editable: false,
            valueGetter: (params) =>
              params.row.alliances?.red?.team_keys?.[0].replace("frc", "") ??
              "N/A",
            cellClassName: (params) =>
              matchData.findIndex((row) => row.time === params.row.time) % 2 ===
              1
                ? "red-cell-light"
                : "red-cell-dark",
            renderCell: (params) => (
              <Paper
                elevation={
                  params.row.alliances?.red?.team_keys?.[0].replace(
                    "frc",
                    ""
                  ) === team
                    ? 3
                    : 0
                }
                sx={{
                  cursor: "pointer",
                  width: { xs: "100%", md: "80%", lg: "65%", xl: "50%" },
                  height: "80%",
                  justifyItems: "center",
                  borderRadius: 4,
                  alignContent: "center",
                  backgroundColor:
                    params.row.alliances?.red?.team_keys?.[0].replace(
                      "frc",
                      ""
                    ) === team
                      ? "#000"
                      : "transparent",
                }}
                onClick={() =>
                  handleTeamClicked(
                    params.row.alliances?.red?.team_keys?.[0].replace("frc", "")
                  )
                }
              >
                <Typography sx={{ fontSize: 14 }}>
                  <u>
                    {params.row.alliances?.red?.team_keys?.[0].replace(
                      "frc",
                      ""
                    ) ?? "N/A"}
                  </u>
                </Typography>
              </Paper>
            ),
          },
          {
            headerName: "Red 2",
            field: "red2",
            flex: 1.5,
            headerAlign: "center",
            align: "center",
            editable: false,
            valueGetter: (params) =>
              params.row.alliances?.red?.team_keys?.[1].replace("frc", "") ??
              "N/A",
            cellClassName: (params) =>
              matchData.findIndex((row) => row.time === params.row.time) % 2 ===
              1
                ? "red-cell-light"
                : "red-cell-dark",
            renderCell: (params) => (
              <Paper
                elevation={
                  params.row.alliances?.red?.team_keys?.[1].replace(
                    "frc",
                    ""
                  ) === team
                    ? 3
                    : 0
                }
                sx={{
                  cursor: "pointer",
                  width: { xs: "100%", md: "80%", lg: "65%", xl: "50%" },
                  height: "80%",
                  justifyItems: "center",
                  borderRadius: 4,
                  alignContent: "center",
                  backgroundColor:
                    params.row.alliances?.red?.team_keys?.[1].replace(
                      "frc",
                      ""
                    ) === team
                      ? "#000"
                      : "transparent",
                }}
                onClick={() =>
                  handleTeamClicked(
                    params.row.alliances?.red?.team_keys?.[1].replace("frc", "")
                  )
                }
              >
                <Typography sx={{ fontSize: 14 }}>
                  <u>
                    {params.row.alliances?.red?.team_keys?.[1].replace(
                      "frc",
                      ""
                    ) ?? "N/A"}
                  </u>
                </Typography>
              </Paper>
            ),
          },
          {
            headerName: "Red 3",
            field: "red3",
            flex: 1.5,
            headerAlign: "center",
            align: "center",
            editable: false,
            valueGetter: (params) =>
              params.row.alliances?.red?.team_keys?.[2].replace("frc", "") ??
              "N/A",
            cellClassName: (params) =>
              matchData.findIndex((row) => row.time === params.row.time) % 2 ===
              1
                ? "red-cell-light"
                : "red-cell-dark",
            renderCell: (params) => (
              <Paper
                elevation={
                  params.row.alliances?.red?.team_keys?.[2].replace(
                    "frc",
                    ""
                  ) === team
                    ? 3
                    : 0
                }
                sx={{
                  cursor: "pointer",
                  width: { xs: "100%", md: "80%", lg: "65%", xl: "50%" },
                  height: "80%",
                  justifyItems: "center",
                  borderRadius: 4,
                  alignContent: "center",
                  backgroundColor:
                    params.row.alliances?.red?.team_keys?.[2].replace(
                      "frc",
                      ""
                    ) === team
                      ? "#000"
                      : "transparent",
                }}
                onClick={() =>
                  handleTeamClicked(
                    params.row.alliances?.red?.team_keys?.[2].replace("frc", "")
                  )
                }
              >
                <Typography sx={{ fontSize: 14 }}>
                  <u>
                    {params.row.alliances?.red?.team_keys?.[2].replace(
                      "frc",
                      ""
                    ) ?? "N/A"}
                  </u>
                </Typography>
              </Paper>
            ),
          },
          {
            headerName: "Blue 1",
            field: "blue1",
            flex: 1.5,
            headerAlign: "center",
            align: "center",
            editable: false,
            valueGetter: (params) =>
              params.row.alliances?.blue?.team_keys?.[0].replace("frc", "") ??
              "N/A",
            cellClassName: (params) =>
              matchData.findIndex((row) => row.time === params.row.time) % 2 ===
              1
                ? "blue-cell-light"
                : "blue-cell-dark",
            renderCell: (params) => (
              <Paper
                elevation={
                  params.row.alliances?.blue?.team_keys?.[0].replace(
                    "frc",
                    ""
                  ) === team
                    ? 3
                    : 0
                }
                sx={{
                  cursor: "pointer",
                  width: { xs: "100%", md: "80%", lg: "65%", xl: "50%" },
                  height: "80%",
                  justifyItems: "center",
                  borderRadius: 4,
                  alignContent: "center",
                  backgroundColor:
                    params.row.alliances?.blue?.team_keys?.[0].replace(
                      "frc",
                      ""
                    ) === team
                      ? "#000"
                      : "transparent",
                }}
                onClick={() =>
                  handleTeamClicked(
                    params.row.alliances?.blue?.team_keys?.[0].replace(
                      "frc",
                      ""
                    )
                  )
                }
              >
                <Typography sx={{ fontSize: 14 }}>
                  <u>
                    {params.row.alliances?.blue?.team_keys?.[0].replace(
                      "frc",
                      ""
                    ) ?? "N/A"}
                  </u>
                </Typography>
              </Paper>
            ),
          },
          {
            headerName: "Blue 2",
            field: "blue2",
            flex: 1.5,
            headerAlign: "center",
            align: "center",
            editable: false,
            valueGetter: (params) =>
              params.row.alliances?.blue?.team_keys?.[1].replace("frc", "") ??
              "N/A",
            cellClassName: (params) =>
              matchData.findIndex((row) => row.time === params.row.time) % 2 ===
              1
                ? "blue-cell-light"
                : "blue-cell-dark",
            renderCell: (params) => (
              <Paper
                elevation={
                  params.row.alliances?.blue?.team_keys?.[1].replace(
                    "frc",
                    ""
                  ) === team
                    ? 3
                    : 0
                }
                sx={{
                  cursor: "pointer",
                  width: { xs: "100%", md: "80%", lg: "65%", xl: "50%" },
                  height: "80%",
                  justifyItems: "center",
                  borderRadius: 4,
                  alignContent: "center",
                  backgroundColor:
                    params.row.alliances?.blue?.team_keys?.[1].replace(
                      "frc",
                      ""
                    ) === team
                      ? "#000"
                      : "transparent",
                }}
                onClick={() =>
                  handleTeamClicked(
                    params.row.alliances?.blue?.team_keys?.[1].replace(
                      "frc",
                      ""
                    )
                  )
                }
              >
                <Typography sx={{ fontSize: 14 }}>
                  <u>
                    {params.row.alliances?.blue?.team_keys?.[1].replace(
                      "frc",
                      ""
                    ) ?? "N/A"}
                  </u>
                </Typography>
              </Paper>
            ),
          },
          {
            headerName: "Blue 3",
            field: "blue3",
            flex: 1.5,
            headerAlign: "center",
            align: "center",
            editable: false,
            valueGetter: (params) =>
              params.row.alliances?.blue?.team_keys?.[2].replace("frc", "") ??
              "N/A",
            cellClassName: (params) =>
              matchData.findIndex((row) => row.time === params.row.time) % 2 ===
              1
                ? "blue-cell-light"
                : "blue-cell-dark",
            renderCell: (params) => (
              <Paper
                elevation={
                  params.row.alliances?.blue?.team_keys?.[2].replace(
                    "frc",
                    ""
                  ) === team
                    ? 3
                    : 0
                }
                sx={{
                  cursor: "pointer",
                  width: { xs: "100%", md: "80%", lg: "65%", xl: "50%" },
                  height: "80%",
                  justifyItems: "center",
                  borderRadius: 4,
                  alignContent: "center",
                  backgroundColor:
                    params.row.alliances?.blue?.team_keys?.[2].replace(
                      "frc",
                      ""
                    ) === team
                      ? "#000"
                      : "transparent",
                }}
                onClick={() =>
                  handleTeamClicked(
                    params.row.alliances?.blue?.team_keys?.[2].replace(
                      "frc",
                      ""
                    )
                  )
                }
              >
                <Typography sx={{ fontSize: 14 }}>
                  <u>
                    {params.row.alliances?.blue?.team_keys?.[2].replace(
                      "frc",
                      ""
                    ) ?? "N/A"}
                  </u>
                </Typography>
              </Paper>
            ),
          },
          {
            headerName: "Red Final",
            field: "redfinal",
            flex: 1,
            headerAlign: "center",
            align: "center",
            editable: false,
            valueGetter: (params) =>
              params.row.score_breakdown?.red?.totalPoints ?? "N/A",
            cellClassName: (params) =>
              params.row.winning_alliance === "red"
                ? "red-cell-dark"
                : matchData.findIndex((row) => row.time === params.row.time) %
                    2 ===
                  1
                ? "grey-cell-light"
                : "grey-cell-dark",
            renderCell: (params) => (
              <Paper
                elevation={
                  params.row.alliances?.red?.team_keys?.some(
                    (key) => key.replace("frc", "") === team
                  )
                    ? 3
                    : 0
                }
                sx={{
                  cursor: "pointer",
                  width: { xs: "100%", md: "80%", lg: "65%", xl: "50%" },
                  height: "80%",
                  justifyItems: "center",
                  borderRadius: 4,
                  alignContent: "center",
                  backgroundColor: params.row.alliances?.red?.team_keys?.some(
                    (key) => key.replace("frc", "") === team
                  )
                    ? "#000"
                    : "transparent",
                }}
              >
                <Typography sx={{ fontSize: 14 }}>
                  {params.row.score_breakdown?.red?.totalPoints}
                </Typography>
              </Paper>
            ),
          },
          {
            headerName: "Blue Final",
            field: "bluefinal",
            flex: 1,
            headerAlign: "center",
            align: "center",
            editable: false,
            valueGetter: (params) =>
              params.row.score_breakdown?.blue?.totalPoints ?? "N/A",
            cellClassName: (params) =>
              params.row.winning_alliance === "blue"
                ? "blue-cell-dark"
                : matchData.findIndex((row) => row.time === params.row.time) %
                    2 ===
                  1
                ? "grey-cell-light"
                : "grey-cell-dark",
            renderCell: (params) => (
              <Paper
                elevation={
                  params.row.alliances?.blue?.team_keys?.some(
                    (key) => key.replace("frc", "") === team
                  )
                    ? 3
                    : 0
                }
                sx={{
                  cursor: "pointer",
                  width: { xs: "100%", md: "80%", lg: "65%", xl: "50%" },
                  height: "80%",
                  justifyItems: "center",
                  borderRadius: 4,
                  alignContent: "center",
                  backgroundColor: params.row.alliances?.blue?.team_keys?.some(
                    (key) => key.replace("frc", "") === team
                  )
                    ? "#000"
                    : "transparent",
                }}
              >
                <Typography sx={{ fontSize: 14 }}>
                  {params.row.score_breakdown?.blue?.totalPoints}
                </Typography>
              </Paper>
            ),
          },
        ]}
        sx={{
          display: "flex",
          minHeight: "125px",
          "& .red-cell-light": {
            backgroundColor: "rgba(90, 0, 0)",
          },
          "& .red-cell-dark": {
            backgroundColor: "rgba(150, 0, 0)",
          },
          "& .blue-cell-light": {
            backgroundColor: "rgba(0, 30, 110)",
          },
          "& .blue-cell-dark": {
            backgroundColor: "rgba(0, 50, 180)",
          },
          "& .grey-cell-light": {
            backgroundColor: "rgba(90, 90, 90)",
          },
          "& .grey-cell-dark": {
            backgroundColor: "rgba(120, 120, 120)",
          },
        }}
        disableSelectionOnClick
        density="compact"
        editMode="row"
        disableVirtualization
        getRowId={(row) => row?.key ?? ""}
      />
    </Box>
  );
}
